import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-zinc-950/95 backdrop-blur-md py-3 shadow-lg shadow-black/50' : 'bg-transparent py-5'}`} data-id="element-71">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-72">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-3 group" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/5czQNt9FGFzYPVyXpCNzhM/crusader-lighting-logo.jpg" alt="Crusader Lighting & Electric Logo" className="h-12 w-auto rounded-sm object-contain bg-white p-1" data-id="element-74" />
          <div className="flex flex-col" data-id="element-75">
            <span className="text-xl md:text-2xl font-black tracking-tighter uppercase text-white group-hover:text-red-600 transition-colors" data-id="element-76">
              Crusader
            </span>
            <span className="text-xs md:text-sm font-bold tracking-widest text-yellow-600 uppercase" data-id="element-77">
              Lighting & Electric
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-78">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-semibold uppercase tracking-wider text-zinc-300 hover:text-white transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-red-600 hover:after:w-full after:transition-all after:duration-300" data-id="element-79">
              {link.name}
            </a>)}
        </nav>

        {/* CTA Button */}
        <div className="hidden md:flex items-center" data-id="element-80">
          <a href="tel:847-555-0198" className="flex items-center gap-2 bg-yellow-600 hover:bg-yellow-500 text-zinc-950 px-6 py-2.5 font-bold uppercase tracking-wide rounded-sm transition-all transform hover:scale-105" data-id="element-81">
            <Phone className="w-4 h-4" data-id="element-82" />
            <span data-id="element-83">Call or Text</span>
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-zinc-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-84">
          {mobileMenuOpen ? <X className="w-8 h-8" data-id="element-85" /> : <Menu className="w-8 h-8" data-id="element-86" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-zinc-900 border-t border-zinc-800 shadow-2xl" data-id="element-87">
          <div className="flex flex-col px-6 py-4 gap-4" data-id="element-88">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-semibold uppercase tracking-wider text-zinc-300 hover:text-white py-2 border-b border-zinc-800" data-id="element-89">
                {link.name}
              </a>)}
            <a href="tel:847-555-0198" className="flex items-center justify-center gap-2 bg-yellow-600 text-zinc-950 px-6 py-4 mt-4 font-bold uppercase tracking-wide rounded-sm" data-id="element-90">
              <Phone className="w-5 h-5" data-id="element-91" />
              <span data-id="element-92">Call or Text 847-555-0198</span>
            </a>
          </div>
        </div>}
    </header>;
}